// extracted by mini-css-extract-plugin
module.exports = {"logo_finition":"logoFinition__logo_finition__3sHgE"};